import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import React, { useMemo } from "react";
import { Col, Row } from "reactstrap";
import footerImage from "../../../../assets/preview/twitter-buttons-footer.png";
import { SocialPost } from "../../../../cores/socialPost/interfaces/api/get-social-posts";
import { useTwitterCore } from "../../../../cores/twitter";
import { DropdownOptions } from "./DropdownOptions";
import { MediaPreview } from "./MediaPreview";

interface Props {
  post: SocialPost;
  onDelete: () => void;
  onEdit: () => void;
}

export const TwitterPostPreview = (props: Props) => {
  const { post, onEdit, onDelete } = props;
  const { settings } = useTwitterCore();
  const { name: defaultName, avatarUrl: defaultAvatar } = settings || {};
  const { publisherName: name, publisherAvatarUrl: avatarUrl } =
    post.post || {};

  const formattedText = useMemo(() => {
    const orderMentions = (post.mention || [])
      .slice()
      .sort((a, b) => (a.offset > b.offset ? -1 : 1));

    let txt = post.post.text;
    orderMentions.forEach((mention) => {
      const name = `<span style="color:#0d4b7e;">@${mention.mentions[0].username}</span>`;
      const offset = mention.offset + mention.mentions[0].username.length + 1;
      txt = txt.slice(0, mention.offset) + name + txt.slice(offset);
    });

    return txt;
  }, [post.mention, post.post.text]);

  return (
    <>
      <Row className="twitterPreview-header">
        <Col xs="2">
          <img
            className="twitterPreview-header-avatar"
            src={avatarUrl || defaultAvatar}
            alt="avatar"
          />
        </Col>
        <Col xs="9" className="twitterPreview-header-description">
          <div className="align-items-end d-flex">
            <span className="twitterPreview-header-name font-weight-bold">
              {name || defaultName}
            </span>
            <div className="text-muted pl-2">
              {post.post.postAt ? (
                moment(post.post.postAt).format("DD MMM YYYY hh:mm a")
              ) : (
                <span className="text-warning">
                  {moment(post.post.scheduleDate).format("DD MMM YYYY hh:mm a")}{" "}
                  <FontAwesomeIcon icon={["far", "clock"]} />
                </span>
              )}
            </div>
          </div>
          <div className="line-break-anywhere pr-4 pre-wrap">
            <div
              dangerouslySetInnerHTML={{
                __html: formattedText,
              }}
            ></div>
          </div>
        </Col>
        <Col xs="1" className="align-content-center d-flex justify-content-end">
          {post.post.status === 0 && (
            <DropdownOptions
              children={
                <FontAwesomeIcon
                  className="mr-3 pointer"
                  icon={["fas", "ellipsis-h"]}
                />
              }
              onEdit={onEdit}
              onDelete={onDelete}
            />
          )}
        </Col>
      </Row>
      <Row>
        <Col xs="12" className="twitterPreview-image-container">
          {post.media.length > 0 && (
            <MediaPreview
              className="twitterPreview-image"
              type={post.post.type}
              media={post.media}
            />
          )}
          <img
            className="twitterPreview-footer"
            src={footerImage}
            alt="footer"
          />
        </Col>
      </Row>
    </>
  );
};
